import React from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { Box, Typography } from "@mui/material";
import useStyles from "./calendar-day-header.style";

export const OcCalendarDayHeader = ({ date }: { date: string | Date }) => {
  const { i18n } = useTranslation();
  let label = moment(date).locale(i18n.language).format("dddd");
  const classes = useStyles();
  return (
    <Box
      height="45px"
      display="flex"
      flexDirection="column"
      justifyContent="center"
    >
      <Typography className={classes.root} color="#5E6366">
        {label}
      </Typography>
    </Box>
  );
};

export default OcCalendarDayHeader;
